namespace Matrix.Administration {
    export class UserLogColumns {
        static columnsKey = 'Administration.UserLog';
    }
}
